import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

const ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
];

const LettersBar = ({ letters }) => (
  <div className={styles.letterBar}>
    <ul>
      {ALPHABET.map(letter => (
        <li key={letter}>
          <a href={`#${letter}`} className={letters.indexOf(letter) === -1 ? 'disabled' : ''} >{letter}</a>
        </li>
      ))}
    </ul>
  </div>
);

LettersBar.propTypes = {
  letters: PropTypes.array
};

LettersBar.defaultProps = {
  letters: []
};

export default LettersBar;
